//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === API ===
import { createUserBulk } from 'api/prokey/prokey.websocket';

// === STYLE ===
import MuiAlert from '@mui/material/Alert';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
} from '@mui/material';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

//#endregion

function BulkAddUserDialog(props) {
  //#region [VALUES]
  const [csvFile, setCsvFile] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertErrText, setAlertErrText] = useState('');

  //#endregion

  //#region [EFFECT]

  useEffect(() => {}, [props.showDialog]);

  //#endregion

  //#region [MODIFY]

  function bulkAddUsers() {
    // Check form, make sure we have all the data we want and it's well formatted
    let errorText = '';
    if (!csvFile) errorText += ', CSV File must be provided';

    if (errorText) {
      setAlertErrText(errorText.substring(2));
      setShowAlert(true);
      return false;
    } else {
      // Read data from incoming file
      const reader = new FileReader();
      // set onload handler
      reader.onload = (e) => {
        setCsvFile(reader.result);
        const newCsvData = reader.result.split(/\r?\n/);
        createUserBulk(newCsvData);
      };
      // load the file
      reader.readAsText(csvFile);

      // Submit data to backend api
      return true;
    }
  }

  const handleCsvFile = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const handleSubmitBulkAddUsers = (e) => {
    if (bulkAddUsers()) handleClose();
  };

  const handleClose = () => {
    props.setShowDialog(false);
    handleDismissAlert();
  };

  const handleDismissAlert = () => {
    setShowAlert(false);
    setAlertErrText('');
  };

  //#endregion

  //#region [DISPLAY]

  // ------------------------------------------------------
  // ALERT

  const handleErrClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };

  const displayError = () => {
    return (
      <Snackbar open={showAlert} autoHideDuration={6000} onClose={handleErrClose}>
        <div>
          <Alert onClose={handleErrClose} severity='error'>
            {alertErrText}
          </Alert>
        </div>
      </Snackbar>
    );
  };

  // ------------------------------------------------------
  // MODAL

  function displayAddUserModal() {
    return props.showDialog ? (
      <div>
        <Dialog open={props.showDialog} onClose={handleClose} aria-labelledby='form-dialog-title'>
          <DialogTitle id='form-dialog-title'>Bulk Add User</DialogTitle>
          <DialogContent>
            <DialogContentText>Enter bulk user file information</DialogContentText>
            <TextField
              autoFocus
              margin='dense'
              id='name'
              label='Bulk User CSV'
              type='file'
              fullWidth
              onChange={handleCsvFile}
              name='choose_add_bulk_users_csv_input'
            />
            <Button onClick={handleClose} color='primary' name='cancel_add_bulk_users_btn'>
              Cancel
            </Button>
            <Button onClick={handleSubmitBulkAddUsers} color='primary' name='add_bulk_users_dialog_btn'>
              Bulk Add
            </Button>
          </DialogContent>
        </Dialog>
        {displayError()}
      </div>
    ) : null;
  }

  //#endregion

  return displayAddUserModal();
}

export { BulkAddUserDialog };
